import { LEAVE_STATUSES, PAYMENT_METHODS } from 'components/global/constants'
import I18n from 'translations/i18n'

const staticRecords = {
  record_types: [
    { name: 'delay', id: 'employee_with_delay' },
    { name: 'absence', id: 'employee_with_absence' },
    { name: 'missing_punch', id: 'employee_with_missing_punch' },
  ],
  uncorrect_data: [
    { name: 'all', id: 'all' },
    { name: 'uncorrect_data', id: 'uncorrect_data' },
    { name: 'correct_data', id: 'correct_data' },
  ],
  gosi_linked_data: [
    { name: 'all', id: 'all' },
    { name: 'not_registered_gosi', id: false },
    { name: 'registered_gosi', id: true },
  ],
  shift_types: [
    { name: 'all', id: 'all' },
    { name: 'normal', id: 'Normal' },
    { name: 'split', id: 'Split' },
    { name: 'flexible', id: 'Flexible' },
  ],
  shift_type: [
    { name: 'all', id: 'all' },
    { name: 'fixed', id: 'fixed' },
    { name: 'rotated', id: 'rotated' },
  ],
  punch_in: [
    { name: 'all', id: 'all' },
    { name: 'no_record', id: 'no_record' },
    { name: 'late_in', id: 'late_in' },
  ],
  punch_out: [
    { name: 'all', id: 'all' },
    { name: 'no_record', id: 'no_record' },
    { name: 'early_out', id: 'early_out' },
  ],
  leave_statuses: LEAVE_STATUSES,
  request_type: [
    // Finance group
    { name: 'expense_claim_request', id: 'ExpenseClaimRequest', group: 'finance' },
    { name: 'loan_cancellation_request', id: 'LoanCancellationRequest', group: 'finance' },
    { name: 'loan_request', id: 'LoanRequest', group: 'finance' },
    {
      name: 'expense_claim_cancellation_request',
      id: 'ExpenseClaimCancellationRequest',
      group: 'finance',
    },
    {
      name: 'final_settlement_review_request',
      id: 'FinalSettlementRequest',
      group: 'finance',
    },
    {
      name: 'vacation_settlement_review_request',
      id: 'VacationSettlementRequest',
      group: 'finance',
    },
    { name: 'payroll_review_request', id: 'RegularReviewRequest', group: 'finance' },

    // Attendance group
    { name: 'excuse_cancellation_request', id: 'ExcuseCancellationRequest', group: 'attendance' },
    { name: 'excuse_request', id: 'ExcuseRequest', group: 'attendance' },
    {
      name: 'missing_punch_cancellation_request',
      id: 'MissingPunchCancellationRequest',
      group: 'attendance',
    },
    { name: 'missing_punch_request', id: 'MissingPunchRequest', group: 'attendance' },
    {
      name: 'overtime_cancellation_request',
      id: 'OvertimeCancellationRequest',
      group: 'attendance',
    },
    { name: 'overtime_request', id: 'OvertimeRequest', group: 'attendance' },

    // Other group
    { name: 'leave_cancellation_request', id: 'LeaveCancellationRequest', group: 'others' },
    { name: 'leave_request', id: 'LeaveRequest', group: 'others' },
    {
      name: 'leave_resumption_cancellation_request',
      id: 'LeaveResumptionCancellationRequest',
      group: 'others',
    },
    { name: 'leave_resumption_request', id: 'LeaveResumptionRequest', group: 'others' },
    {
      name: 'business_trip_cancellation_request',
      id: 'BusinessTripCancellationRequest',
      group: 'others',
    },
    { name: 'business_trip_request', id: 'BusinessTripRequest', group: 'others' },
    {
      name: 'exit_reentry_visa_cancellation_request',
      id: 'ExitReentryVisaCancellationRequest',
      group: 'others',
    },
    { name: 'exit_reentry_visa_request', id: 'ExitReentryVisaRequest', group: 'others' },
    { name: 'asset_cancellation_request', id: 'AssetCancellationRequest', group: 'others' },
    { name: 'asset_request', id: 'AssetRequest', group: 'others' },
    {
      name: 'asset_clear_cancellation_request',
      id: 'AssetClearCancellationRequest',
      group: 'others',
    },
    { name: 'asset_clear_request', id: 'AssetClearRequest', group: 'others' },
    { name: 'hiring_cancellation_request', id: 'HiringCancellationRequest', group: 'others' },
    { name: 'hiring_request', id: 'HiringRequest', group: 'others' },
    {
      name: 'resignation_cancellation_request',
      id: 'ResignationCancellationRequest',
      group: 'others',
    },
    { name: 'resignation_request', id: 'ResignationRequest', group: 'others' },
    { name: 'delegation_request', id: 'DelegationRequest', group: 'others' },
    { name: 'document_request', id: 'DocumentRequest', group: 'others' },
    { name: 'info_change_request', id: 'InfoChangeRequest', group: 'others' },
    { name: 'letter_request', id: 'LetterRequest', group: 'others' },
  ],
  tasks_request_type: [
    { name: 'loan_payment_task', id: 'loan_payment_task' },
    { name: 'payroll_payment_task', id: 'payroll_payment_task' },
    { name: 'employee_gosi_registration_task', id: 'employee_gosi_registration_task' },
    { name: 'gosi_salary_updation_task', id: 'gosi_salary_updation_task' },
    { name: 'expense_claim_payment_task', id: 'expense_claim_payment_task' },
    { name: 'advance_vacation_salary_payment_task', id: 'advance_vacation_salary_payment_task' },
    { name: 'final_settlement_payment_task', id: 'final_settlement_payment_task' },
    { name: 'exit_reentry_payment_task', id: 'exit_reentry_payment_task' },
    { name: 'ticket_payment_task', id: 'ticket_payment_task' },
    { name: 'issuing_ticket_task', id: 'issuing_ticket_task' },
    { name: 'business_trip_payment_task', id: 'business_trip_payment_task' },
    { name: 'letter_issuing_task', id: 'letter_issuing_task' },
    { name: 'asset_allocation_task', id: 'asset_allocation_task' },
    { name: 'asset_deallocation_task', id: 'asset_deallocation_task' },
  ],
  request_statuses: [
    { name: 'all', id: 'all' },
    { name: 'pending', id: 'Pending' },
    { name: 'approved', id: 'Approved' },
    { name: 'rejected', id: 'Rejected' },
    { name: 'expired', id: 'Expired' },
    { name: 'canceled', id: 'Cancelled' },
  ],
  ats_job_opening_statuses: [
    { name: 'all', id: 'all' },
    { name: 'open', id: 'open' },
    { name: 'draft', id: 'draft' },
    { name: 'closed', id: 'closed' },
  ],
  candidate_statuses: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('assigned'), id: 'assigned' },
    { name: I18n.t('not_assigned'), id: 'unAssigned' },
  ],
  tasks_request_statuses: [
    { name: 'all', id: 'all' },
    { name: 'pending', id: 'Pending' },
    { name: 'completed', id: 'Completed' },
    { name: 'cancelled', id: 'Cancelled' },
  ],
  task_statuses: [
    { name: 'completed', id: 'Completed' },
    { name: 'pending', id: 'Pending' },
  ],
  tasks_categories: [
    { name: 'exit_reentry_payment_task', id: 'exit_reentry_payment_task' },
    { name: 'ticket_payment_task', id: 'ticket_payment_task' },
    { name: 'issuing_ticket_task', id: 'issuing_ticket_task' },
    { name: 'loan_payment_task', id: 'loan_payment_task' },
    { name: 'advance_vacation_salary_payment_task', id: 'advance_vacation_salary_payment_task' },
    { name: 'final_settlement_payment_task', id: 'final_settlement_payment_task' },
    { name: 'business_trip_payment_task', id: 'business_trip_payment_task' },
    { name: 'expense_claim_payment_task', id: 'expense_claim_payment_task' },
    { name: 'payroll_payment_task', id: 'payroll_payment_task' },
    { name: 'employee_gosi_registration_task', id: 'employee_gosi_registration_task' },
    { name: 'gosi_salary_updation_task', id: 'gosi_salary_updation_task' },
    { name: 'letter_issuing_task', id: 'letter_issuing_task' },
  ],
  leave_types: [{ name: 'business_trip', id: 'Business trip' }],
  statuses: [
    { name: 'active', id: 1 },
    { name: 'inactive', id: 2 },
  ],

  document_type_status: [
    { name: 'expired', id: 'expired' },
    { name: 'not_expired', id: 'not expired' },
  ],
  payment_methods: PAYMENT_METHODS,
  status_employee: [
    { name: 'all', id: 'all' },
    { name: 'under_probation', id: 'Under_probation' },
  ],

  employment_document_type: [
    { id: 'ID', name: 'ID', name_i18n: I18n.t('id_constants') },
    { id: 'Iqama', name: 'Iqama', name_i18n: I18n.t('iqama') },
    { id: 'Passport', name: 'Passport', name_i18n: I18n.t('passport') },
  ],
  payrun_types: [
    { name: 'vacation_settlement', id: 'vs' },
    { name: 'final_settlement', id: 'eos' },
  ],
  payrun_status: [
    { name: 'paid', id: 'paid' },
    { name: 'confirmed', id: 'confirmed' },
  ],
  payroll_transaction_status: [
    { name: 'open', id: 'initiated' },
    { name: 'cancelled', id: 'cancelled' },
    { name: 'paid', id: 'paid' },
  ],
  assetStatuses: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('available'), id: 'Available' },
    { name: I18n.t('allocated'), id: 'Allocated' },
    { name: I18n.t('inrepair'), id: 'In-Repair' },
    { name: I18n.t('damaged'), id: 'Damaged' },
    { name: I18n.t('archived'), id: 'Archived' },
  ],
  pending_on: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('from_you'), id: 'self' },
    { name: I18n.t('from_other_approvals'), id: 'others' },
  ],
  tasks_pending_on: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('you'), id: 'self' },
    { name: I18n.t('others_2'), id: 'others' },
  ],
  filter_payrun_status: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('open'), id: 'draft' },
    { name: I18n.t('pending_on_approval'), id: 'under_review' },
    { name: I18n.t('approved'), id: 'confirmed' },
    { name: I18n.t('rejected'), id: 'changes_required' },
    { name: I18n.t('paid'), id: 'paid' },
    { name: I18n.t('cancelled'), id: 'cancelled' },
  ],
  filter_attendance_status: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('attendance_requested'), id: 'pending' },
    { name: I18n.t('attendance_approved'), id: 'confirmed' },
    { name: I18n.t('attendance_dismissed'), id: 'dismissed' },
    { name: I18n.t('no_attendance_request'), id: 'no_attendance' },
  ],
  payment_processing_methods: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('Cash'), id: 'Cash' },
    { name: I18n.t('International Transfer'), id: 'International Transfer' },
    { name: I18n.t('Cheque'), id: 'Cheque' },
    { name: I18n.t('Bank'), id: 'Bank' },
  ],
  insurance_statuses: [
    { name: I18n.t('insurance_statuse_draft'), id: 'draft' },
    { name: I18n.t('insurance_statuse_rejected'), id: 'rejected' },
    { name: I18n.t('pending_payment'), id: 'pending_payment' },
    { name: I18n.t('action_required'), id: 'action_required' },
    { name: I18n.t('insurance_statuse_pending_approval'), id: 'pending_approval' },
    { name: I18n.t('under_review'), id: 'under_review' },
    { name: I18n.t('insurance_statuse_completed'), id: 'completed' },
  ],
  member_linked_data: [
    { name: I18n.t('all'), id: 'all' },
    { name: I18n.t('linked'), id: true },
    { name: I18n.t('not_linked'), id: false },
  ],
}

export default staticRecords
